import { Injectable } from '@angular/core';
import { BaseService, HttpOptions } from '@makiwin/ngx-drupal8-rest';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FeedbackService extends BaseService {
  postReqFeedback(data: any): Observable<any> {
    const httpOptions: HttpOptions = {
      method: 'post',
    };
    return this.request(httpOptions, '/recreational_feedback/submit', data);
  }

  postProFeedback(data: any): Observable<any> {
    const httpOptions: HttpOptions = {
      method: 'post',
    };
    return this.request(httpOptions, '/pro_feedback/submit', data);
  }
}
